var React = require('react');

function Fcicon (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_3007_14796)","key":0},[React.createElement("path",{"d":"M4 31L24.0002 17.9998L44.0004 31L24.0002 44.0002L4 31Z","fill":"#E8EFFF","fillOpacity":"0.3","key":0}),React.createElement("path",{"d":"M4 24L24.0002 10.9998L44.0004 24L24.0002 37.0002L4 24Z","fill":"#060F20","key":1}),React.createElement("path",{"d":"M4 24L24.0002 10.9998L44.0004 24L24.0002 37.0002L4 24Z","fill":"#E8EFFF","fillOpacity":"0.7","key":2}),React.createElement("path",{"d":"M3.99951 17L23.9997 3.99979L43.9999 17L23.9997 30.0002L3.99951 17Z","fill":"#E8EFFF","key":3})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_3007_14796"},React.createElement("rect",{"width":"48","height":"48","fill":"white"})))]);
}

Fcicon.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = Fcicon;

Fcicon.default = Fcicon;
